import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Almacen} from '../models/Almacen';

@Injectable({
  providedIn: 'root'
})
export class AlmacenService {

  private readonly url = environment.almacenesUrl;

  constructor(private readonly httpClient: HttpClient) { }

  public getAll(): Observable<Almacen[]> {
    return this.httpClient.get<Almacen[]>(this.url);
  }
}
